import React, {useState} from "react";
import {Box, IconButton} from "@mui/material";
import {IconArrowsDiagonal} from "@tabler/icons-react";
import {Editor} from "@monaco-editor/react";
import {NodeType} from "../../../../../model/ModelData";
import {menuItemsInfo} from "../editMenuItems";
import {ParserModal} from "../../../../../components/modals/ParserModal";
import {UI, rgba} from "../../uiTokens";
import {iconBtnSx} from "../editMenuStyles";
import {SectionHeader, SubSectionHeader} from "../components/EditMenuSection";

export const OutputParserTab = ({node, setNode, onUpdate}) => {
    const [expand, setExpand] = useState(false);

    const {primary, hook, secondary} = menuItemsInfo.output_parser;
    const isHook = node?.type === NodeType.HOOK;
    const dataKey = isHook ? "api_output_parser" : "parser";
    const code = node?.data?.[dataKey] || "";

    const onChangeData = (key, value) => {
        setNode(prev => {
            const state = {...prev};
            state.data[key] = value;
            onUpdate(state);
            return state;
        });
    };

    return (
        <>
            <ParserModal
                handleClose={() => setExpand(false)}
                open={expand}
                onSuccess={(content) => onChangeData(dataKey, content)}
                text={code}
            />

            <SectionHeader title={isHook ? hook : primary} description={secondary}/>

            <Box>
                <SubSectionHeader
                    title="Javascript"
                    action={
                        <IconButton size="small" sx={iconBtnSx} onClick={() => setExpand(true)}>
                            <IconArrowsDiagonal size={15}/>
                        </IconButton>
                    }
                />
                <Box
                    onClick={() => setExpand(true)}
                    sx={{
                        mt: 0.75,
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: `1px solid ${rgba(UI.ink, 0.12)}`,
                        cursor: "pointer",
                        "&:hover": {borderColor: rgba(UI.accent, 0.4)},
                    }}
                >
                    <Editor
                        height="200px"
                        defaultLanguage="javascript"
                        value={code}
                        options={{readOnly: true, minimap: {enabled: false}, fontSize: 12, scrollBeyondLastLine: false}}
                    />
                </Box>
            </Box>
        </>
    );
};
